import { AnchorButton, Card, Heading, Stack, Text } from '@instabox/consumer-web-ui'
import { FC } from 'react'
import { FormattedMessage } from 'react-intl'
import { GetMarketByIdQuery } from '@instabox/consumer-web-shared'

export type WorkWithUSProps = GetMarketByIdQuery['marketById']

const WorkWithUS: FC<WorkWithUSProps> = ({ locations_email, merchants_email }) => {
  const emailRe = /\S+@\S+\.\S+/
  const locationsHref = emailRe.test(locations_email)
    ? `mailto:${locations_email}`
    : locations_email
  const merchantsHref = emailRe.test(merchants_email)
    ? `mailto:${merchants_email}`
    : merchants_email
  return (
    <Card variant="secondary" size="md">
      <Stack gap="lg">
        <Heading color="white" as="h6">
          <FormattedMessage id="help.work_with_us.title" />
        </Heading>
        <Text color="white">
          <FormattedMessage id="help.work_with_us.subtitle" />
        </Text>
        <div className="row">
          <div className="col-12 col-lg-6">
            <AnchorButton
              target="_blank"
              rel="noopener"
              fluid
              size="large"
              variant="solid"
              href={locationsHref}>
              <FormattedMessage id="help.contact.locations" />
            </AnchorButton>
          </div>
          <div className="col-12 col-lg-6">
            <AnchorButton
              target="_blank"
              rel="noopener"
              fluid
              size="large"
              variant="solid"
              href={merchantsHref}>
              <FormattedMessage id="help.contact.merchants" />
            </AnchorButton>
          </div>
        </div>
      </Stack>
    </Card>
  )
}

export default WorkWithUS
